import { type GraphKindConfig, GraphKinds, PhaseTypes } from '@/components/phasesCurve/interfaces.ts';
import { $diastoleColor, $systoleColor } from '@/assets/branding/branding.constants.ts';

const annulusSizeName = 'Annulus Size';
const rvVolumeName = 'RV Volume';
const curveColorId = 'curveColor';

const graphKindConfig: GraphKindConfig = {
  [GraphKinds.RVVolume]: {
    label: rvVolumeName,
    units: ' cm³',
    unitsLabel: rvVolumeName,
    paramName: 'rvVolume',
    factor: 0.001
  },
  [GraphKinds.AnnulusSize]: {
    label: annulusSizeName,
    units: ' cm',
    unitsLabel: annulusSizeName,
    paramName: 'annulusSize',
    factor: 0.1
  }
};

const phaseTypeColorConfig = {
  [PhaseTypes.Systole]: {
    color: $systoleColor,
    label: PhaseTypes.Systole
  },
  [PhaseTypes.Diastole]: {
    color: $diastoleColor,
    label: PhaseTypes.Diastole
  }
};

export { graphKindConfig, phaseTypeColorConfig, curveColorId };
